import React from 'react';

const LOGIN_AS_LINK_TTL = 60000;

export const isLoginAsToken = (token) => typeof token === 'string' && token.length > 0 && !/[<>\s]/.test(token);

const LoginAsButton = (props) => {
    const { passportUserName, className, handleLoginAsUser, getLoginAsToken } = props;
    const [loginAsToken, setLoginAsToken] = React.useState(null);
    const [isLoadingToken, setIsLoadingToken] = React.useState(false);
    const clearTokenTimeout = React.useRef(null);

    React.useEffect(() => {
        return () => clearTimeout(clearTokenTimeout.current);
    }, []);

    const onMouseEnter = async () => {
        if (loginAsToken || isLoadingToken) {
            return;
        }

        setIsLoadingToken(true);

        const token = await getLoginAsToken(passportUserName);

        setIsLoadingToken(false);

        if (isLoginAsToken(token)) {
            setLoginAsToken(token);
            clearTokenTimeout.current = setTimeout(() => setLoginAsToken(null), LOGIN_AS_LINK_TTL);
        }
    }

    const onClick = (e) => {
        e.preventDefault();
        handleLoginAsUser(passportUserName);
    }

    return (
        <a className={`DMButton btn btn-block btn-default ${className}`}
            href={loginAsToken ? `/Account/Logout#loginAs=${encodeURIComponent(loginAsToken)}` : undefined}
            style={isLoadingToken ? { cursor: 'progress' } : undefined}
            onMouseEnter={onMouseEnter}
            onClick={onClick}>
            Login
        </a>
    );
};

export default LoginAsButton;
